import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=58a54bb9"
import script from "./BlankLayout.vue?vue&type=script&lang=js"
export * from "./BlankLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports